// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"317":"e7eb9a9f","621":"849c74e1","743":"85c5b7ab","917":"ddf208f3"}[chunkId] + ".chunk.js";
};